import { useCallback } from 'react';
import type { SelectOption } from '../simple-select';
import { useSelectOptions } from './use-select-options';

interface UseSimpleSelectProps {
  options: SelectOption[];
  value?: string;
  onChange: (value: string | undefined) => void;
}

export function useSimpleSelect({ options, value, onChange }: UseSimpleSelectProps) {
  const { items, getLabel, getValue, getKeywords } = useSelectOptions(options);

  const selectedLabel = getLabel(value);

  const handleValueChange = useCallback(
    (selectedLabel: string | null) => {
      if (!selectedLabel) {
        onChange(undefined);
        return;
      }
      const selectedValue = getValue(selectedLabel);
      onChange(selectedValue);
    },
    [getValue, onChange]
  );

  return {
    items,
    selectedLabel,
    handleValueChange,
    getKeywords
  };
}
